export enum EntityStoreKey {
  invitations = 'invitations',
}
